import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/config' };
/////////////////////////////////////////////////////////////////////////////////

export function getConfig() {
  return httpService.get({ ...args, args: `/1` });
}